import React, { useState, useEffect } from 'react';
import { isEmpty } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import SystemMasterTabel from '../../Components/SystemMasterTabel/SystemMasterTabel';
import * as action from './Store/SystemMasters.action';
import ConfirmationPopup from '../../Components/ModalPopup/ConfirmationPopup';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';

const tempObj = {
  name: null,
  isEmpty: false,
  isNew: true,
  isActive: true,
  hasLength: false,
  _id: '',
};

function SeasonMaster() {
  const dispatch = useDispatch();
  const reducer = useSelector((estate) => estate);
  const {
    SystemMastersDetails,
    UserDetails,
    Users: { logInRights },
  } = reducer;
  const { seasonList } = SystemMastersDetails;
  const { userInfo } = UserDetails;

  const { t } = useTranslation('common');
  const loggedInUserId = userInfo.userId;

  const [isLoadingSeason, setIsLoadingSeason] = useState(false);
  const [showSeason, setShowSeason] = useState(false);
  const [isSeasonUnique, setIsSeasonUnique] = useState(true);
  const [buttonDownSeason, setButtonDownSeason] = useState(true);
  const [seasonBtnDisable, setSeasonsBtnDisable] = useState(false);
  const [addingSeasons, setAddingSeasons] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showConfirmationAD, setShowConfirmationAD] = useState(false);
  const [isLoadingConf, setIsLoadingConf] = useState(false);
  const [isSeason, setIsSeason] = useState(false);
  const [seasonData, setSeasonData] = useState([]);
  const [isUniqSeasonId, setIsUniqSeasonId] = useState([]);
  const [deleteId, setDeleteId] = useState('');
  const [activeInactiveID, setActiveInactiveID] = useState('');
  const { CheckActionPermission } = useComponent();
  const [userRights, setUserRights] = useState({});
  useEffect(() => {
    if (logInRights) {
      setUserRights(logInRights);
    }
  }, [logInRights]);
  const MasterAddEditAccess = CheckActionPermission(userRights, 'masters', 'season', 'addEdit');
  const MasterDeleteAccess = CheckActionPermission(userRights, 'masters', 'season', 'delete');

  useEffect(() => {
    setSeasonData(seasonList);
    if (addingSeasons) {
      setSeasonData([
        ...seasonList,
        {
          name: null,
          isEmpty: false,
          isNew: true,
          isActive: true,
          _id: '',
          aliasName: '',
        },
      ]);
    }
  }, [seasonList, addingSeasons]);

  const callApi = async () => {
    setButtonDownSeason(!buttonDownSeason);
    setIsLoadingSeason(true);
    buttonDownSeason ? setShowSeason(true) : setShowSeason(false);
    const sParams = {
      loggedInUserId,
    };
    isEmpty(seasonData) && (await dispatch(action.getSeasonsDetails(sParams)));
    setIsLoadingSeason(false);
  };

  const handleChanged = (event, i) => {
    const seasons = [...seasonData];
    setIsUniqSeasonId([]);
    setIsSeasonUnique(true);
    if (event.target.name === 'aliasName') {
      seasons[i] = {
        ...seasons[i],
        aliasName: event.target.value,
      };
    } else {
      seasons[i] = {
        ...seasons[i],
        name: event.target.value,
        isEmpty: event.target.value === '',
      };
    }
    const arr = [];
    const arrIndex = [];
    seasons.forEach((ele, ind) => {
      seasons.forEach((objs, index) => {
        if (ele.name === objs.name && ind !== index) {
          arr.push(ele);
          arrIndex.push(index);
        }
      });
    });
    if (!isEmpty(arr)) {
      const arrs = [...arrIndex];
      const removeArss = Math.min(...arrs);
      const newArr = arrIndex.filter((ele) => ele !== removeArss);
      setIsUniqSeasonId([...newArr]);
    }
    setIsSeasonUnique(isEmpty(arr));
    let isDisableSeason = false;
    seasons.forEach((seasonElement) => {
      if (isEmpty(seasonElement?.name?.trim())) {
        isDisableSeason = true;
      }
    });
    setSeasonsBtnDisable(isDisableSeason);
    setSeasonData(seasons);
  };

  const addSeasons = async () => {
    if (!showSeason) {
      setAddingSeasons(true);
      setButtonDownSeason(!buttonDownSeason);
      setIsLoadingSeason(true);
      buttonDownSeason ? setShowSeason(true) : setShowSeason(false);
      const sParams = {
        loggedInUserId,
      };
      isEmpty(seasonData) && (await dispatch(action.getSeasonsDetails(sParams)));
      setIsLoadingSeason(false);
    } else if (!isEmpty(seasonData)) {
      setSeasonData([...seasonData, tempObj]);
    } else {
      setSeasonData([tempObj]);
    }
  };

  const handleDelete = (id) => {
    if (typeof id === 'number' || id === '') {
      seasonData.splice(id, 1);
      let sids = false;
      seasonData.forEach((seasonElement) => {
        if (isEmpty(seasonElement?.name?.trim())) {
          sids = true;
        }
      });
      setSeasonsBtnDisable(sids);
      setIsSeasonUnique(true);
      setIsUniqSeasonId([]);
      setSeasonData([...seasonData]);
    } else {
      setDeleteId(id);
      setShowConfirmation(true);
    }
  };

  const saveSeasons = async () => {
    setIsSeason(true);
    if (!isEmpty(seasonData)) {
      const emptyField = await seasonData.filter((ssitem) => ssitem.name === null || ssitem.name === '');
      if (isEmpty(emptyField)) {
        const data = seasonData.map((seasobj) => {
          return { ...seasobj, name: seasobj?.name?.trim(), aliasName: seasobj?.aliasName ? seasobj.aliasName.trim() : '' };
        });
        const seasonSaveParams = {
          loggedInUserId,
          seasons: JSON.stringify(data),
          title: 'seasons',
          showAlias: true,
        };
        setAddingSeasons(false);
        await dispatch(action.saveToSystemMaster(seasonSaveParams, t));
        const sParams = {
          loggedInUserId,
        };
        await dispatch(action.getSeasonsDetails(sParams));
        // post API
      } else {
        const newState = seasonData.map((sSobj) => (sSobj?.isEmpty === false && sSobj.name === null ? { ...sSobj, isEmpty: true } : sSobj));
        setSeasonData(newState);
      }
    }
    setIsSeason(false);
  };

  const activeInactiveClicked = (id) => {
    setShowConfirmationAD(true);
    setActiveInactiveID(id);
  };

  useEffect(() => {
    const array = [];
    seasonData.forEach((ele, index) => {
      seasonData.forEach((obj, places) => {
        if (index !== places && ele?.name === obj?.name) {
          array.push(ele);
        }
      });
    });
    if (isEmpty(array)) {
      setIsSeasonUnique(isEmpty(array));
      setIsUniqSeasonId([]);
    }
  }, [seasonData]);

  const deleteConfirmed = async () => {
    setIsLoadingConf(true);
    const seasonParams = {
      loggedInUserId,
      seasonId: deleteId,
      title: 'seasons',
    };
    await dispatch(action.deleteFromSystemMasters(seasonParams, t));
    setIsLoadingConf(false);
    setShowConfirmation(false);
    setSeasonData([...seasonList]);
    const sParams = {
      loggedInUserId,
    };
    await dispatch(action.getSeasonsDetails(sParams));
  };

  const activeInactiveConfirmed = async () => {
    setIsLoadingConf(true);
    let ssn = {};
    seasonData.forEach((ele) => {
      if (ele._id === activeInactiveID) {
        ele.isActive = !ele.isActive;
        const data = {
          ...ele,
          loggedInUserId,
          title: 'seasons',
        };
        ssn = data;
      }
    });
    await dispatch(action.setActiveInactive(ssn, t));
    setIsLoadingConf(false);
    setShowConfirmationAD(false);
    setSeasonData([...seasonData]);
  };

  return (
    <>
      <SystemMasterTabel
        isLoading={isLoadingSeason}
        setShow={showSeason}
        callApi={callApi}
        buttonDown={buttonDownSeason}
        mainData={seasonData}
        handleChanged={handleChanged}
        addBtnClicked={addSeasons}
        deletPressed={handleDelete}
        onSave={saveSeasons}
        isDesabled={isSeason}
        title={t('SEASONS_MASTER.TITLE')}
        masterAddEditAccess={MasterAddEditAccess}
        masterDeleteAccess={MasterDeleteAccess}
        inputName={t('SEASONS_MASTER.INPUT_NAME')}
        activeInactiveClicked={activeInactiveClicked}
        btnDisable={seasonBtnDisable}
        isUnique={isSeasonUnique}
        isUniqueId={isUniqSeasonId}
        showAlias
      />
      {showConfirmation && (
        <ConfirmationPopup
          onOpen={showConfirmation}
          onConfirm={() => deleteConfirmed()}
          title={t('SEASONS_MASTER.DELETE_CONFIRMATION.TITLE')}
          message={t('SEASONS_MASTER.DELETE_CONFIRMATION.MESSAGE')}
          toggle={() => setShowConfirmation(!showConfirmation)}
          loading={isLoadingConf}
        />
      )}
      {showConfirmationAD && (
        <ConfirmationPopup
          onOpen={showConfirmationAD}
          onConfirm={() => activeInactiveConfirmed()}
          title={t('SEASONS_MASTER.ACTIVE_INACTIVE_CONFIRMATION.TITLE')}
          message={t('SEASONS_MASTER.ACTIVE_INACTIVE_CONFIRMATION.MESSAGE')}
          toggle={() => setShowConfirmationAD(!showConfirmationAD)}
          loading={isLoadingConf}
        />
      )}
    </>
  );
}

export default SeasonMaster;
